import Tracker from './Tracker';
import type { initTracker } from './Tracker';

export default class Comscore extends Tracker {
  constructor(args: initTracker) {
    super({ ...args, type: 'comscore' });
  }

  renderHtmlInBody = () => {
    const { id } = this;

    return `
            <script type="text/plain" class="optanon-category-2" async>
                var _comscore;
                var s;
                var el;

                if (typeof window !== 'undefined' && !window._comscore) {
                    _comscore = _comscore || [];
                    window._comscore = _comscore;
                    window._comscore.push({
                        c1: '2',
                        c2: '${id}',
                        options: {
                          url_append: 'comscorekw=rentals'
                        }
                    });
                }
            </script>
            <script type="text/plain" src="https://sb.scorecardresearch.com/beacon.js" async class="optanon-category-2"></script>
        `;
  };

  trackPageView = (_: unknown, cb: (s: string) => void) => {
    this.logger &&
      this.logger.debug(
        {
          id: this.id,
        },
        'trackPageView',
      );

    if (!this.drymode) {
      // window.COMSCORE is created by the injected script
      if (typeof window !== 'undefined' && window.COMSCORE) {
        window.COMSCORE.beacon({
          c1: '2',
          c2: this.id,
          options: {
            url_append: 'comscorekw=rentals',
          },
        });

        if (cb) {
          cb(this.id);
        }
      }
    }

    return this.result(true);
  };

  trackEvent = () => {
    this.logger && this.logger.debug('comscore has no trackEvent action');
  };
}
